import React from 'react';
import '../../../styles/landing.css';
import '../../../styles/route.css';
import EstimateWidget from './EstimateWidget';

/**
 * The hero, per Redesign v2: a claim on the left, a working estimate on the right.
 *
 * There is deliberately no button in the copy column. The estimate widget's
 * "Book now" is the page's first Signal Yellow action, and the system allows
 * exactly one per viewport — a second CTA here would spend the accent twice and
 * compete with the number that is actually doing the persuading. The three
 * points below the sub-heading carry the supporting claims instead.
 */

const HERO_POINTS = ['Route estimate first', 'Live tracking', 'Verified drivers'];

const HeroSection: React.FC = () => {
  return (
    <section className="landing-hero sw-hero">
      <div className="container sw-hero-grid">
        <div className="sw-hero-copy">
          <span className="sw-eyebrow">Bakkies &amp; trucks · on demand</span>

          <h1 className="sw-hero-heading">
            Too big for the car?
            <br />
            Book a bakkie.
          </h1>

          <p className="sw-hero-sub">
            Enter your route, see an estimate <em>before</em> you confirm, and track the
            driver the whole way. Final fare is confirmed before dispatch, with driver
            approval for complex loads.
          </p>

          <ul className="sw-hero-points">
            {HERO_POINTS.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </div>

        {/* #estimate is the target for every "get an estimate" link on the site. */}
        <div className="sw-hero-media" id="estimate">
          <EstimateWidget />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
